import { faList } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const TutorialList = ({ lisData, onClose, setTutorialData }) => {

    const selectTutorial = (data) => {
        setTutorialData(data)
    }

    return (
        <div className="tutorial-list-container" onClick={onClose}>
            <div className="list-flap">
                {lisData?.map((data) => {
                    return (
                        <button 
                            className="list-data-unit"
                            onClick={() => selectTutorial(data)}
                        >
                            <FontAwesomeIcon icon={faList} className="list-icon" />
                            <span className="doc-name">{data?.title}</span>
                        </button>
                    )
                })}
            </div>
        </div>
    );
}